import queryKeys from '@/constants/queryKeys';
import appRoutes from '@/constants/routes/app';
import { patchProvider } from '@/services/api/requests/providers';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { TProviderApi } from '@/types/Provider.types';

const usePatchProvider = (id: string) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: async ({ form, photo }: { form: TProviderApi; photo: File | null }) => {
      const response = await patchProvider({ form, photo, id });
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.providers.all, queryKeys.providers.byId, id] });
      toast({ status: 'success', title: 'Success', description: 'Provider successfully updated.' });
      navigate({ to: appRoutes.providers });
    },
    onError: (error: TCustomAxiosError) => {
      toast({ status: 'error', title: 'Updating provider error', description: error.errors?.[0]?.message });
    },
  });

  return { isPending, isSuccess, mutate };
};

export default usePatchProvider;
